import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { SettingsService } from 'src/app/core/services/settings.service';
import { Entity } from 'src/app/core/models/entity.model';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { mimesysConfig, SettingsMimesys } from 'src/app/core/models/settings.model';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Package } from 'src/app/core/models/package.model';
import { DomSanitizer } from '@angular/platform-browser';
import { PackageType } from 'src/app/core/models/package-type.model';
import { EntityService } from 'src/app/core/services/entity.service';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/core/services/config.service';
import { FileSpecsService } from 'src/app/core/services/file-specs.service';

//powerpoint https://docs.google.com/presentation/d/1ZjmMZS_TQH5P29KSCvM1MwzBJlCaRR4Y/edit#slide=id.p8

@Component({
  selector: 'hbo-setting-mimesys',
  templateUrl: './setting-mimesys.component.html',
  styleUrls: ['./setting-mimesys.component.scss']
})
export class SettingMimesysComponent implements OnInit, OnChanges, OnDestroy {

  @Input() entity!: Entity;
  @Input() isOpen = false;
  @Input() apps!: number[];
  @Output() reload: EventEmitter<any> = new EventEmitter();
  @Output() setApps: EventEmitter<any> = new EventEmitter();
  //testing
  //appsTesting: number[] = [1];
  public utils = utils;

  hideShopTemplateImages: boolean = true;

  saveDisabled: boolean = false
  allowedAppsInitialized: boolean = false;

  extensions = ['png', 'jpg', 'jpeg', 'PNG', 'JPG', 'JPEG'];
  extensionsVideo = ['mp4'];
  fileExtError: { [key: string | number]: any } = {};

  maxFileSize: number = 100000;
  maxFileSizePDF: number = 1000000;
  maxFileSizeVideo: number = 50000000;
  maxFileSizeChunk: number = 5000000;
  maxFileSizeExceed: { [key: string | number]: any } = {};

  logosList: string[] = mimesysConfig.config['logos'];

  services: { id: number, apiName: string }[] = mimesysConfig.config['services'];

  appsAbrev: { id: number, typeId: number, abrev: string }[] = mimesysConfig.config['appsAbrev'];

  packageTypes: { id: number, value: string, apps: string[], appsTypeId: number[], preview: string, previewImgSubmenu: string, previewDesk: string, layout: string, layoutImgSubmenu: string, layoutImgDesk: string, wallPreview: string, wallLayout: string, pdfLayout: string, pdfLayoutFoldBrochure: string }[] = mimesysConfig.config['packageTypes'];
  packageTypeItem!: { id: number, value: string, apps: string[], appsTypeId: number[], preview: string, previewImgSubmenu: string, previewDesk: string, layout: string, layoutImgSubmenu: string, layoutImgDesk: string, wallPreview: string, wallLayout: string, pdfLayout: string, pdfLayoutFoldBrochure: string };

  licenseName: string = '';
  previewImgWelcome!: string;
  previewImgSubmenu!: string;
  previewImgDesk!: string;
  previewImgWall!: string;
  layoutImgWelcome!: string;
  layoutImgSubmenu!: string;
  layoutImgDesk!: string;
  layoutImgWall!: string;
  layoutImgPdf!: string;
  layout: boolean = false;
  showLayoutLogos!: boolean;
  previewLayout!: string;
  previewLayoutPDFType: string = '';

  templates: { id: number, value: string }[] = mimesysConfig.config['templates'];

  mapsDisplay: { id: number, value: string }[] = mimesysConfig.config['mapsDisplay'];

  enviromentLensPro: { id: number, value: string }[] = mimesysConfig.config['enviromentLensPro'];
  enviromentLensOffice: { id: number, value: string }[] = mimesysConfig.config['enviromentLensOffice'];
  enviromentLensSvision: { id: number, value: string }[] = mimesysConfig.config['enviromentLensSvision'];
  enviromentCoachProgre: { id: number, value: string }[] = mimesysConfig.config['enviromentCoachProgre'];
  enviromentCoachOffice: { id: number, value: string }[] = mimesysConfig.config['enviromentCoachOffice'];
  enviromentLauncher: { id: number, value: string }[] = mimesysConfig.config['enviromentLauncher'];
  static_images: { folder: string, ext: string, sufix: string } = { folder: 'opticalStore', ext: 'png', sufix: '' };
  enviromentComparison: { id: number, value: string }[] = mimesysConfig.config['enviromentComparison'];

  additionalMapsDisplay: { id: number, value: string }[] = mimesysConfig.config['additionalMapsDisplay'];

  appsLicensed!: { id: number, abrev: string }[];
  appsList =  [
    {id: 'mimesys', name: 'Mimesys'},
    { id: 'novaai', name: 'NovaAi' },
    { id: 'kudos', name: 'KUDOS' },
    { id: 'vreyegesture', name: 'VR Eye Gesture'},
    { id: 'synthesis', name: 'SYNTHESIS'},
    { id: 'stepperoptiai', name: 'STEPPER OPTI AI'},
    { id: 'mimetika2', name: 'MimetikaVR'},
    { id: 'mimesysnewlook', name: 'Mimesys New Look'},
    { id: 'demomimesys', name: 'DEMO-mimesys' },
    { id: 'mimesysmainland', name: 'Mimesys Mainland' }
  ];
  package!: Package;




  /*---listener language settings form change
    //let set different settings for different language*/
  mainSettings: boolean = true;

  user: User = utils?.localStorageGetItem('user');

  showSettings = false;
  currentSettings?: SettingsMimesys;

  languages: { id: number, name: string, value: string }[] = [];

  translateServiceLstnr: Subscription = new Subscription;
  settingsLanguageFormLstnr: Subscription = new Subscription;
  settingsEnabledFormLstnr: Subscription = new Subscription;
  settingsTemplateFormLstnr: Subscription = new Subscription;

  base64Img: { id: string, base64: string }[] = [];

  actualFilenames: { [key: string]: string } = {};
  parentEntityId: FormControl<number | null> = new FormControl();


  logo1Default: FormControl = new FormControl;
  logo3Default: FormControl = new FormControl;
  ergoCorridorLogoDefault: FormControl = new FormControl;
  videoFileDefault: FormControl = new FormControl;

  settingsForm = this.formBuilder.nonNullable.group({
    logo1: [''],
    logo2: [''],
    logo3: [''],
    distributorLogo: [''],
    mimesysProductLogo: [''],
    lensLogo: [''],
    coachLogo: [''],
    progressiveLogo: [''],
    officeLogo: [''],
    svisionLogo: [''],
    progressiveLogoSubmenu: [''],
    officeLogoSubmenu: [''],
    svisionLogoSubmenu: [''],
    ergoCorridorLogo: [''],
    entityId: 1,
    parentEntityId: this.parentEntityId,
    language: [this.translateService.currentLang.split('-')[0]],
    appUser: '',
    appPwd: '',
    logo1Default: this.logo1Default,
    logo1Parent: false,
    template: this.templates.find(el => el.id == 1)!.value,
    coverImage: [''],
    insidePageImage: [''],
    color: '',
    logo3Default: this.logo3Default,
    logo3Parent: false,
    logo1Allow: false,
    logo3Allow: false,
    distributorLogoAllow: false,
    onlyVisibleBy: false,
    // progresiveBasicName: '',
    // progresiveMidName: '',
    // progresiveTopName: '',
    enviromentLensPro: this.enviromentLensPro.find(el => el.id == 1)!.value,
    enviromentLensOffice: this.enviromentLensOffice.find(el => el.id == 1)!.value,
    enviromentLensSvision: this.enviromentLensSvision.find(el => el.id == 1)!.value,
    enviromentCoachProgre: this.enviromentCoachProgre.find(el => el.id == 1)!.value,
    enviromentCoachOffice: this.enviromentCoachOffice.find(el => el.id == 1)!.value,
    enviromentLauncher: this.enviromentLauncher.find(el => el.id == 1)!.value,
    enviromentComparison: this.enviromentComparison.find(el => el.id == 1)!.value,
    enabled: false,
    service: this.services.find(el => el.id == 1)!.apiName,
    externalReportingEnabled: false,
    main: this.mainSettings,
    requestToken: '',
    shortTestID: false,
    ergoCorridorEnable: false,
    ergoCorridorLogoDefault: this.ergoCorridorLogoDefault,
    ergoCorridorName: '',
    ergoCorridorLogoParent: false,
    videoFileParent: false,
    videoFileDefault: this.videoFileDefault,
    mapsDisplay: this.mapsDisplay.find(el => el.id == 1)!.value,
    gazeType: true,
    amplitudeRatio: true,
    maxFrequencyVector: true,
    diagnostic: true,
    additionalMapsDisplay: this.additionalMapsDisplay.find(el => el.id == 1)!.value,
    screenSaverEnabled: false,
    screenSaverFileName: "",
    screenSaverMimeType: "",
    screenSaverVideo: [''],
    allowedApps: [[], [Validators.required, Validators.minLength(1)]]
  });

  videoFile!: File;
  hierarchy!: any;

  error!: boolean;
  errorMessage!: string

  constructor(
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    private settingsService: SettingsService,
    private entityService: EntityService,
    private router: Router,
    private configSvc: ConfigService,
    private fileSpecsService: FileSpecsService
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
  }
  @HostListener('window:resize', ['$event'])
  onResize(e: Event) {
    if (this.isOpen) {
      setTimeout(() => {
        this.getLogosPosition();
      }, 0);
    }

  }
  ngOnInit() {
    /*if (this.configSvc.currentConfigValue.paginations!['settings'].entityId === this.entity.id) {
      this.licenseName = this.getLicenseName();
      console.log(this.licenseName);
      this.showSettings = false;
      this.getSettings();
    }*/
    this.translateServiceLstnr = this.translateService.onLangChange.subscribe(data => {
      //this.setLanguages();
      if (this.isOpen) {
        this.getSettings();
      }
    });

    /*this.setLanguages();*/
    /*---listener language settings form change
    //let set different settings for different language*/
    //if (!this.mainSettings) this.settingsLanguageFormLstnr = this.settingsForm.controls.language.valueChanges.subscribe(value => this.getSettings(value));
    this.settingsEnabledFormLstnr = this.settingsForm.controls.enabled.valueChanges.subscribe(value => value ? this.checkToken() : null);
    this.settingsTemplateFormLstnr = this.settingsForm.controls.template.valueChanges.subscribe(value => {
      this.previewLayoutPDFType = value;
      switch (value) {
        case 'Bi-fold brochure':
          this.layoutImgPdf = 'bi-fold-brochure.svg';
          break;
        default:
          this.layoutImgPdf = 'mimesys-pdf.svg';
          break;
      }

    });
    this.settingsForm.controls.allowedApps.valueChanges.subscribe(() => {
      this.checkAllFiles();
    });
    this.settingsForm.controls.service.valueChanges.subscribe(value => {
      if (value && value !== 'None') {
        this.settingsForm.patchValue({ externalReportingEnabled: true });
      } else {
        this.settingsForm.patchValue({ externalReportingEnabled: false });
      }
    });
  }

  ngOnDestroy() {
    this.translateServiceLstnr.unsubscribe();
    this.settingsTemplateFormLstnr.unsubscribe();
    /*---listener language settings form change
    //let set different settings for different language*/
    if (!this.mainSettings) this.settingsLanguageFormLstnr.unsubscribe();
    this.settingsEnabledFormLstnr.unsubscribe();

  }

  ngOnChanges(changes: { [property: string]: SimpleChange }) {
    if (changes['isOpen']?.currentValue) {
      if (this.apps && this.apps.length > 0) {
        this.configApps();
        this.showSettings = false;
        this.getSettings();
      }
    }
    if (changes['apps'] && this.isOpen && this.apps && this.apps.length > 0) {
      this.configApps();
      if (!this.showSettings) {
        this.showSettings = false;
        this.getSettings();
      }
    }
  }

  configApps() {
    if (!this.apps || this.apps.length === 0) {
      console.warn('configApps called but apps not yet available');
      return;
    }
    let appsIds: { id: number, typeId: number, abrev: string }[] = [];
    this.apps.map(app => this.appsAbrev.find(item => {
      if (item.typeId == app) appsIds.push(item)
      }))
    appsIds = appsIds.filter((abrev, index, array) => array.indexOf(abrev) === index);
    console.log('apps', this.apps, appsIds);
  }

  hasApps(appIds: number[]): boolean {
    return appIds.every((id: number) => this.apps.includes(id));
  }

  hasAnyApp(appIds: number[]): boolean {
    return appIds.some((id: number) => this.apps.includes(id));
  }

  hasProgressive(): boolean {
    // Apps 1, 2 (Progressive)
    const hasProgressive = [1, 2].some((id: number) => this.apps.includes(id));
    return hasProgressive;
  }

  hasOffice(): boolean {
    // Apps 3, 4 (Office)
    const hasOffice = [3, 4].some((id: number) => this.apps.includes(id));
    return hasOffice;
  }

  hasLens(): boolean {
    // Apps 1, 3, or 8 (Lens)
    const hasLens = [1, 3, 8].some((id: number) => this.apps.includes(id));
    return hasLens;
  }

  hasCoach(): boolean {
    // Apps 2, 4 (Coach)
    const hasCoach = [2, 4].some((id: number) => this.apps.includes(id));
    return hasCoach;
  }

  hasMultipleLensApps(): boolean {
    // Check if there are at least 2 lens apps (1, 3, 8)
    const lensApps = [1, 3, 8];
    const count = lensApps.filter((id: number) => this.apps.includes(id)).length;
    return count >= 2;
  }


  areArraysEqual = (arr1: any[], arr2: any[]) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.sort().toString() === arr2.sort().toString();
  }
  arrayContains = (arr1: any[], arr2: any[]) => {
    return arr2.every(elem => arr1.includes(elem));
  }

  determineLayoutImages() {
    // Determine all layout and preview images based on available apps
    // Apps: LP (1), CP (2), LO (3), CO (4), LS (8)
    const hasLP = this.apps.includes(1);
    const hasCP = this.apps.includes(2);
    const hasLO = this.apps.includes(3);
    const hasCO = this.apps.includes(4);
    const hasLS = this.apps.includes(8);

    // Determine preview images
    if (hasLP && hasCP && hasLO && hasCO && hasLS) {
      // All 5 apps
      this.previewImgWelcome = 'welcome-Preview-B-C-D';
      this.previewImgSubmenu = 'submenu-Preview-B-C-E-F-G';
      this.layoutImgWelcome = 'welcome-Layout-B-C-D';
      this.layoutImgSubmenu = 'submenu-Layout-B-C-E-F-G';
    } else if (hasLP && hasCP && hasLO && hasCO) {
      // Elite: LP, LO, CP, CO
      this.previewImgWelcome = 'welcome-Preview-B-C-D';
      this.previewImgSubmenu = 'submenu-Preview-B-C-E-F';
      this.layoutImgWelcome = 'welcome-Layout-B-C-D';
      this.layoutImgSubmenu = 'submenu-Layout-B-C-E-F';
    } else if (hasLP && hasCP && hasLS && !hasLO && !hasCO) {
      // LP, CP, LS
      this.previewImgWelcome = 'welcome-Preview-B-C-D';
      this.previewImgSubmenu = 'submenu-Preview-B-C-E-G';
      this.layoutImgWelcome = 'welcome-Layout-B-C-D';
      this.layoutImgSubmenu = 'submenu-Layout-B-C-E-G';
    } else if (hasLP && hasCP && !hasLO && !hasCO && !hasLS) {
      // Synergy: LP, CP
      this.previewImgWelcome = 'welcome-Preview-B-C-D';
      this.previewImgSubmenu = '';
      this.layoutImgWelcome = 'welcome-Layout-B-C-D';
      this.layoutImgSubmenu = 'empty';
    } else if (hasLP && hasLO && !hasCP && !hasCO && !hasLS) {
      // Plus: LP, LO
      this.previewImgWelcome = 'welcome-Preview-B-E-F';
      this.previewImgSubmenu = '';
      this.layoutImgWelcome = 'welcome-Layout-B-E-F';
      this.layoutImgSubmenu = 'empty';
    } else if (hasLP && hasLO && hasLS && !hasCP && !hasCO) {
      // LP, LO, LS
      this.previewImgWelcome = 'welcome-Preview-B-E-F-G';
      this.previewImgSubmenu = '';
      this.layoutImgWelcome = 'welcome-Layout-B-E-F-G';
      this.layoutImgSubmenu = 'empty';
    } else if (hasLP && hasLS && !hasCP && !hasLO && !hasCO) {
      // LP, LS
      this.previewImgWelcome = 'welcome-Preview-B-E-G';
      this.previewImgSubmenu = '';
      this.layoutImgWelcome = 'welcome-Layout-B-E-G';
      this.layoutImgSubmenu = 'empty';
    } else if (hasLP && !hasCP && !hasLO && !hasCO && !hasLS) {
      // Essential: LP only
      this.previewImgWelcome = 'welcome-Preview-B';
      this.previewImgSubmenu = '';
      this.layoutImgWelcome = 'welcome-Layout-B';
      this.layoutImgSubmenu = 'empty';
    } else {
      // Default fallback
      this.previewImgWelcome = 'welcome-Preview-B';
      this.previewImgSubmenu = '';
      this.layoutImgWelcome = 'welcome-Layout-B';
      this.layoutImgSubmenu = 'empty';
    }

    // Desk and Wall are same for all
    this.previewImgDesk = 'desk-Preview-A';
    this.previewImgWall = 'wall_preview';
    this.layoutImgDesk = 'desk-Layout-A';
    this.layoutImgWall = 'wall_layout';
  }


  setCombinedPackageType = (item: any) => {
    this.packageTypeItem = item;
    let name = item.value;
    this.layoutImgPdf = this.settingsForm.controls.template.value === 'Bi-fold brochure'
      ? 'bi-fold-brochure.svg'
      : 'mimesys-pdf.svg';
    return name
  }

  reset() {
    this.saveDisabled = false;
    this.fileExtError = {};
    this.maxFileSizeExceed = {};
  }

  setSettingsAncestor(): Promise<{ data: any; base64: string }> {
    return new Promise((resolve, reject) => {
      this.entityService.getAncestor(this.entity).subscribe(
        async res => {
          let parentEntity = res.parentEntity;
          let object = {
            "hierarchy": {
              "shop_id": String(this.entity.internalCode ? this.entity.internalCode : this.entity.id),
              "ancestor": this.entity?.entityTypeId != 1
                ? {
                  "shop_id": String(parentEntity?.internalCode ? parentEntity?.internalCode : parentEntity?.id),
                  "ancestor": this.entity?.entityTypeId != 2
                    ? {
                      "shop_id": String(parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.id),
                      "ancestor": parentEntity?.parentEntity?.entityTypeId == 2
                        ? {
                          "shop_id": String(parentEntity?.parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.parentEntity?.id),
                          "ancestor": null
                        }
                        : null
                    }
                    : null
                }
                : null
            }
          }
          resolve({ data: object, base64: utils.objectToBase64(object) });
          //resolve({ data: object, base64: utils.objectToBase64(object) });
        });
    });
  }

  getSettings(_lan?: string) {
    this.reset();
    this.setSettingsAncestor().then(res => {
      this.hierarchy = res.base64;
      /*if (this.configSvc.currentConfigValue.paginations!['settings'].settings![this.entity.id]!
      && this.configSvc.currentConfigValue.paginations!['settings'].settings![this.entity.id]['mimesys']!) {
      console.log(this.configSvc.currentConfigValue.paginations!['settings'].settings![this.entity.id]['mimesys']!),
        this.apps = this.configSvc.currentConfigValue.paginations!['settings']!.apps![this.entity.id],
        this.licenseName = this.getLicenseName(),
        this.showSettings = false,
        this.setSettings(this.configSvc.currentConfigValue.paginations!['settings'].settings![this.entity.id]['mimesys']!)
    } else {*/
      // this.settingsService.getMimesys(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId, this.entity.email, _lan ? _lan : this.translateService.currentLang).subscribe(res => {
      //   console.log('SETTINGS MIMSEYS RESPOSTA')
      //   console.log(res)
      //   this.configSvc.setConfigSettingsValue('settings', this.entity.id, 'mimesys', res);
      //   this.licenseName = this.getLicenseName();
      //   console.log(this.licenseName);
      //   this.showSettings = false;
      //   this.setSettings(res);
      // });

      this.settingsService.getMimesys(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId, this.entity.email, _lan ? _lan : this.translateService.currentLang).subscribe(
        res => {
          console.log('SETTINGS MIMSEYS RESPOSTA')
          console.log(res)
          this.configSvc.setConfigSettingsValue('settings', this.entity.id, 'mimesys', res);
          this.configApps();
          this.showSettings = false;
          this.setSettings(res);
        },
        err => {
          if (err.status == 404) {
            this.settingsService.updateMimesys(this.entity.internalCode ? this.entity.internalCode : this.entity.id, this.hierarchy, this.entity.entityTypeId, { "settings": { "timezone": this.entity.timezone } }).subscribe(
              res => {
                this.settingsService.getMimesys(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId, this.entity.email, _lan ? _lan : this.translateService.currentLang).subscribe(
                  res => {
                    console.log('SETTINGS MIMSEYS RESPOSTA')
                    console.log(res)
                    this.configSvc.setConfigSettingsValue('settings', this.entity.id, 'mimesys', res);
                    this.configApps()
                    this.showSettings = false;
                    this.setSettings(res);
                  },
                  err => {
                    console.log("errorrrr", err);
                    console.log(err.status)
                  }
                )
              },
              err => {
                console.log("errorrrr", err);
                console.log(err.status)
              }
            )
          } else {
            console.log("errorrrr", err);
            console.log(err.status)
          }
        }
      );

    });
    //}
  }
  refreshSettings = (e: Event, _lan?: string) => {
    this.entityService.getEntityApps(this.entity.id).subscribe(res => {
      this.configSvc.setConfigAppsValue('settings', this.configSvc.currentConfigValue.paginations!['settings'].entityId!, res.appsIds);
      this.apps = res.appsIds;
      this.setApps.emit(res.appsIds);
      this.configSvc.setConfigAppsValue('settings', this.configSvc.currentConfigValue.paginations!['settings'].entityId!, res.appsIds);
      this.reset();
      this.settingsService.getMimesys(this.entity.id, this.hierarchy, this.entity.entityTypeId, this.entity.email, _lan ? _lan : this.translateService.currentLang).subscribe(res => {
        this.configSvc.setConfigSettingsValue('settings', this.entity.id, 'mimesys', res);
        this.configApps()
        this.showSettings = false;
        this.setSettings(res);
      });
    });

  }

  setSettings(_settings: SettingsMimesys) {
    this.setLanguagesFromXls(_settings['langs']);
    if (_settings['langs']) {
      this.setLanguagesFromXls(_settings['langs']);
      this.configSvc.setConfigSettingsValue('settings', this.entity.id, 'mimesysLangs', _settings['langs']);
      delete _settings['langs'];
    } else {
      this.setLanguagesFromXls(this.configSvc.currentConfigValue.paginations!['settings'].settings![this.entity.id]['mimesysLangs']!);
    }
    this.setForm(_settings);
    this.configSvc.setConfigSettingsValue('settings', this.entity.id, 'mimesys', _settings);
    this.appsLicensed = [];
    this.apps.map((license: number) => {
      let match: { id: number, abrev: string } = this.appsAbrev.find(match => match.id === license && !this.appsLicensed.find(match => match.id == license))!;
      match ? this.appsLicensed.push(match) : null
    })
    console.log(this.appsLicensed);
    this.determineLayoutImages();
    this.showSettings = true;
    this.staticImagesLauncher(this.settingsForm.controls.enviromentLauncher.value);
  }

  staticImagesLauncher = (_value: string) => {
    switch (this.settingsForm.controls.enviromentLauncher.value) {
      case 'OpticalStore':
        this.static_images = { folder: 'opticalStore', ext: 'png', sufix: '' };
        break;
      case 'OpticalStore - Beta':
        this.static_images = { folder: 'opticalStoreBeta', ext: 'jpg', sufix: '_Beta' };
        console.log(this.static_images)
        break;
      case 'Lobby - Stepper':
        this.static_images = { folder: 'opticalStoreStepper', ext: 'jpg', sufix: '_Stepper' };
        break;
      default:
        break;
    }
  }

  getLicenses(_entityId: number) {
    this.settingsService.getPackage(this.entity.id).subscribe(res => {
      this.package = res;
      this.showSettings = true;
    }, error => {
      this.error = true;
      this.errorMessage = JSON.stringify(error)
      this.showSettings = false;
    });
  }

  previewImageWelcome() {
    //let url = `assets/images/preview/mimesys/${this.previewImgWelcome}`;
    let url = `assets/images/preview/mimesys/${this.static_images.folder}/${this.previewImgWelcome}${this.static_images.sufix}.${this.static_images.ext}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  previewImageSubmenu() {
    //let url = `assets/images/preview/mimesys/${this.previewImgSubmenu}`;
    let url = `assets/images/preview/mimesys/${this.static_images.folder}/${this.previewImgSubmenu}${this.static_images.sufix}.${this.static_images.ext}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  previewImageDesk() {
    //let url = `assets/images/preview/mimesys/${this.previewImgDesk}`;
    let url = `assets/images/preview/mimesys/${this.static_images.folder}/${this.previewImgDesk}${this.static_images.sufix}.${this.static_images.ext}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  previewImageWall() {
    //let url = `assets/images/preview/mimesys/${this.previewImgDesk}`;
    let url = `assets/images/preview/mimesys/${this.static_images.folder}/${this.previewImgWall}${this.static_images.sufix}.${this.static_images.ext}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  previewImageTemplate() {
    let url = `assets/images/preview/mimesys/${this.layoutImgPdf}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  layoutImage() {
    let url: string = '';
    switch (this.previewLayout) {
      case 'logo1':
        //url = `assets/images/preview/mimesys/${this.layoutImgWall}`;
        url = `assets/images/preview/mimesys/${this.static_images.folder}/${this.layoutImgWall}${this.static_images.sufix}.${this.static_images.ext}`;
        break;
      case 'submenu':
        //url = `assets/images/preview/mimesys/${this.layoutImgSubmenu}`;
        url = `assets/images/preview/mimesys/${this.static_images.folder}/${this.layoutImgSubmenu}${this.static_images.sufix}.${this.static_images.ext}`;
        break;
      case 'desk':
        //url = `assets/images/preview/mimesys/${this.layoutImgDesk}`;
        url = `assets/images/preview/mimesys/${this.static_images.folder}/${this.layoutImgDesk}${this.static_images.sufix}.${this.static_images.ext}`;
        break;
      case 'pdf':
        url = `assets/images/preview/mimesys/${this.layoutImgPdf}`;
        break;
      default:
        //url = `assets/images/preview/mimesys/${this.layoutImgWelcome}`;
        url = `assets/images/preview/mimesys/${this.static_images.folder}/${this.layoutImgWelcome}${this.static_images.sufix}.${this.static_images.ext}`;
        break;
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  setForm(res: SettingsMimesys) {
    this.base64Img = [];
    this.currentSettings = res;

    this.settingsForm.patchValue({
      additionalMapsDisplay: res.additionalMapsDisplay ?? this.additionalMapsDisplay.find(el => el.id == 1)!.value,
      amplitudeRatio: res.amplitudeRatio,
      appPwd: res.appPwd,
      appUser: res.appUser,
      color: res.color,
      diagnostic: res.diagnostic,
      distributorLogo: '',
      enabled: res.externalRequest?.enabled,
      entityId: res.entityId,
      ergoCorridorEnable: res.ergoCorridorEnable,
      ergoCorridorLogoDefault: res.ergoCorridorLogoDefault!,
      ergoCorridorLogoParent: res.ergoCorridorLogoParent ? res.ergoCorridorLogoParent : false,
      ergoCorridorName: res.ergoCorridorName,
      gazeType: res.gazeType,
      language: res.language! || this.translateService.currentLang.split('-')[0],
      logo1Allow: res.appFrontendDesign?.logo1?.allowConfiguration,
      logo1Default: res.logo1Default!,
      logo1Parent: res.logo1Parent ? res.logo1Parent : false,
      logo3Allow: res.appFrontendDesign?.logo3?.allowConfiguration,
      distributorLogoAllow: res.appFrontendDesign?.distributorLogo?.allowConfiguration,
      logo3Default: res.logo3Default!,
      logo3Parent: res.logo3Parent ? res.logo3Parent : false,
      main: true,
      mapsDisplay: res.mapsDisplay ?? this.mapsDisplay.find(el => el.id == 1)!.value,
      maxFrequencyVector: res.maxFrequencyVector,
      onlyVisibleBy: res.onlyVisibleBy,
      enviromentLensPro: res.environments_3d?.lp_environment_id ? this.enviromentLensPro.find(el => el.id == res.environments_3d.lp_environment_id)!.value : this.enviromentLensPro.find(el => el.id == 1)!.value,
      enviromentLensOffice: res.environments_3d?.lo_environment_id ? this.enviromentLensOffice.find(el => el.id == res.environments_3d.lo_environment_id)!.value : this.enviromentLensOffice.find(el => el.id == 1)!.value,
      enviromentCoachProgre: res.environments_3d?.cp_environment_id ? this.enviromentCoachProgre.find(el => el.id == res.environments_3d.cp_environment_id)!.value : this.enviromentCoachProgre.find(el => el.id == 1)!.value,
      enviromentCoachOffice: res.environments_3d?.co_environment_id ? this.enviromentCoachOffice.find(el => el.id == res.environments_3d.co_environment_id)!.value : this.enviromentCoachOffice.find(el => el.id == 1)!.value,
      enviromentLauncher: res.environments_3d?.launcher_environment_id ? this.enviromentLauncher.find(el => el.id == res.environments_3d.launcher_environment_id)!.value : this.enviromentLauncher.find(el => el.id == 1)!.value,
      enviromentComparison: res.environments_3d?.comparison_environment_id ? this.enviromentComparison.find(el => el.id == res.environments_3d.comparison_environment_id)!.value : this.enviromentComparison.find(el => el.id == 1)!.value,
      enviromentLensSvision: res.environments_3d?.ls_environment_id ? this.enviromentLensSvision.find(el => el.id == res.environments_3d.ls_environment_id)!.value : this.enviromentLensSvision.find(el => el.id == 1)!.value,
      // progresiveBasicName: res.progresiveBasicName,
      // progresiveMidName: res.progresiveMidName,
      // progresiveTopName: res.progresiveTopName,
      parentEntityId: res.parentEntityId,
      requestToken: res.externalRequest?.requestToken,
      service: res.externalReporting?.service,
      externalReportingEnabled: res.externalReporting?.enabled,
      shortTestID: res.shortTestID,
      template: res.template ?? this.templates.find(el => el.id == 1)!.value,
      screenSaverEnabled: res.screenSaver?.enabled,
      screenSaverFileName: res.screenSaver?.fileName!,
      screenSaverMimeType: res.screenSaver?.mimeType!,
      allowedApps: res['allowedApps'] || [],
    });
    this.allowedAppsInitialized = true;
    this.settingsForm.controls.requestToken.disable();
    res.screenSaver?.fileName ? this.settingsForm.controls.screenSaverEnabled.enable() : this.settingsForm.controls.screenSaverEnabled.disable();

    // Disable distributor specific settings for non-owner users
    if (this.user.profileId !== 3) {
      this.settingsForm.controls.additionalMapsDisplay.disable();
      this.settingsForm.controls.allowedApps.disable();
      this.settingsForm.controls.amplitudeRatio.disable();
      this.settingsForm.controls.diagnostic.disable();
      this.settingsForm.controls.enabled.disable();
      this.settingsForm.controls.enviromentCoachOffice.disable();
      this.settingsForm.controls.enviromentCoachProgre.disable();
      this.settingsForm.controls.enviromentComparison.disable();
      this.settingsForm.controls.enviromentLauncher.disable();
      this.settingsForm.controls.enviromentLensOffice.disable();
      this.settingsForm.controls.enviromentLensPro.disable();
      this.settingsForm.controls.enviromentLensSvision.disable();
      this.settingsForm.controls.ergoCorridorEnable.disable();
      this.settingsForm.controls.ergoCorridorLogo.disable();
      this.settingsForm.controls.ergoCorridorLogoDefault.disable();
      this.settingsForm.controls.ergoCorridorLogoParent.disable();
      this.settingsForm.controls.ergoCorridorName.disable();
      this.settingsForm.controls.gazeType.disable();
      this.settingsForm.controls.mapsDisplay.disable();
      this.settingsForm.controls.maxFrequencyVector.disable();
      this.settingsForm.controls.onlyVisibleBy.disable();
      this.settingsForm.controls.requestToken.disable();
      this.settingsForm.controls.screenSaverEnabled.disable();
      this.settingsForm.controls.screenSaverFileName.disable();
      this.settingsForm.controls.screenSaverMimeType.disable();
      this.settingsForm.controls.screenSaverVideo.disable();
      this.settingsForm.controls.service.disable();
      this.settingsForm.controls.shortTestID.disable();
    }

    this.layoutImgPdf = this.settingsForm.controls.template.value === 'Bi-fold brochure'
      ? 'bi-fold-brochure.svg'
      : 'mimesys-pdf.svg';

    if (this.entity.id === this.user.entityId && this.user.profileId !== 3 && !(this.user.roleId === 4 && this.user.profileId === 1)) {
      this.settingsForm.disable();
    }
  }

  checkToken() {
    if (!this.settingsForm.controls.requestToken.value || this.settingsForm.controls.requestToken.value == 'None') {
      this.settingsForm.controls.requestToken.patchValue(utils.signToken(this.entity.id, 'JaKUsKBLlUmEuwNAKZh37WdtfUcdL1'))
    }
  }

  persistanceBase64Img(_img: string, _base64: string) {
    this.base64Img.push({ id: _img, base64: _base64?.split(',')[1] })
    return null
  }

  base64ImgExists(_img: string) {
    return this.base64Img.find(img => img.id == _img)?.base64
  }

  setLanguages() {
    this.languages = [];
    this.translateService.getLangs().map((lan: string, index: number) => {
      this.languages.push({ id: index, name: this.translateService.instant(`COMMON.LANGUAGES.NAMES.${lan}`), value: lan })
    });
    this.languages = this.languages.sort((a, b) => a.name.localeCompare(b.name))
  }
  setLanguagesFromXls(_langs: { id: number, name: string, value: string }[]) {
    this.languages = _langs;
    console.log(this.languages);
    if (this.languages) this.languages = this.languages.sort((a, b) => a.value.localeCompare(b.value))
  }

  toBase64(fileInput: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      const file = (document.querySelector('#' + fileInput + '-' + this.entity.id) as HTMLInputElement).files?.[0];
      if (file) {
        reader.readAsDataURL(file as Blob);
        reader.onload = () => resolve(reader.result?.toString() ?? '');
        reader.onerror = reject;
      } else {
        resolve('');
      }
    });
  }

  cleanParams(originalParams: any) {
    const cleanProps: any = {};
    // Recorrer las propiedades del objeto original para copiarlas al nuevo objeto
    for (const key in originalParams) {
      // Solo copiar la propiedad si tiene valor
      if (originalParams[key] || originalParams[key] === false || originalParams[key] === "") {
        if (typeof originalParams[key] === 'object' && !(originalParams[key] instanceof Array)) {
          // Si la propiedad es un objeto se llama recursivamente a esta funcion con esta propiedad y se asigna el resultado
          const cleanProp: object = this.cleanParams(originalParams[key]);
          if (Object.keys(cleanProp).length) {
            cleanProps[key] = cleanProp;
          }
        } else {
          // Si la propiedad no es un objeto se asigna directamente
          cleanProps[key] = originalParams[key];
        }
      }
    }
    return cleanProps;
  }

  preview(_type?: string) {
    this.previewLayout = _type!;
    this.layout = !this.layout;
    setTimeout(() => {
      this.getLogosPosition();
      this.layout ? this.showLayoutLogos = true : this.showLayoutLogos = false;
    }, 500);
  }

  logos: any;
  @ViewChild('previewLayoutObject') previewLayoutObject!: ElementRef;
  getLogosPosition() {
    if (this.previewLayoutObject) {

      let layouWidthOri = 1280;
      let layouHeightOri = 720;

      let logoWidthOri = 900;
      let logoHeightOri = 200;

      let logoABWidth = 310;
      let logoABHeight = 80;


      let logoCDWidth = 150;
      let logoCDHeight = 45;

      let logoEFWidth = 150;
      let logoEFHeight = 45;

      let logoGFWidth = 150;
      let logoGFHeight = 45;

      let logo1Width = 450;
      let logo1Height = 140;

      let layouWidthOriPdfBi = 842;
      let layouHeightOriPdfBi = 1195;

      let imageCoverWidth = 842;
      let imageCoverHeight = 595;

      let insidePageImageWidth = 842;
      let insidePageImageHeight = 595;


      let offsetY = this.previewLayoutObject.nativeElement.getBoundingClientRect().top;
      let offsetX = this.previewLayoutObject.nativeElement.getBoundingClientRect().left;
      let offsetH = this.previewLayoutObject.nativeElement.getBoundingClientRect().height;
      let offsetW = this.previewLayoutObject.nativeElement.getBoundingClientRect().width;
      let adjustMaxWidth = window.innerWidth > 1700 ? ((window.innerWidth - 1700) / 2) - 8 : 0;
      this.logos = {
        window: { x: 0, y: 0, w: window.innerWidth, h: window.innerHeight },
        object: { x: 0, y: this.previewLayoutObject.nativeElement.getBoundingClientRect().top, w: this.previewLayoutObject.nativeElement.getBoundingClientRect().width, h: this.previewLayoutObject.nativeElement.getBoundingClientRect().height },
        logoA:
        {
          'opticalStore': this.previewLayout
            ? {
              x: (offsetW * 530 / layouWidthOri) + adjustMaxWidth,
              y: offsetH * 440 / layouHeightOri + offsetY,
              w: offsetW * (logoABWidth - 30) / layouWidthOri,
              h: offsetH * (logoABHeight - 20) / layouHeightOri
            }
            : {
              x: (offsetW * 530 / layouWidthOri) + adjustMaxWidth,
              y: offsetH * 440 / layouHeightOri + offsetY,
              w: offsetW * (logoABWidth - 20) / layouWidthOri,
              h: (this.hasLens() && !this.hasCoach())
                ? offsetH * (logoABHeight - 30) / layouHeightOri
                : offsetH * (logoABHeight - 30) / layouHeightOri

            },
          'opticalStoreBeta': this.previewLayout
            ? {
              x: (offsetW * 536 / layouWidthOri) + adjustMaxWidth,
              y: offsetH * 422 / layouHeightOri + offsetY,
              w: offsetW * (logoABWidth - 100) / layouWidthOri,
              h: offsetH * (logoABHeight - 30) / layouHeightOri
            }
            : {
              x: (offsetW * 530 / layouWidthOri) + adjustMaxWidth,
              y: offsetH * 440 / layouHeightOri + offsetY,
              w: offsetW * (logoABWidth - 20) / layouWidthOri,
              h: offsetH * (logoABHeight - 30) / layouHeightOri
            },
          'opticalStoreStepper': this.previewLayout
            ? {
              x: (offsetW * 405 / layouWidthOri) + adjustMaxWidth,
              y: offsetH * 185 / layouHeightOri + offsetY,
              w: offsetW * (logoABWidth * 1.75 - 100) / layouWidthOri,
              h: offsetH * ((logoABHeight * 1.75) - 30) / layouHeightOri
            }
            : {
              x: (offsetW * 530 / layouWidthOri) + adjustMaxWidth,
              y: offsetH * 440 / layouHeightOri + offsetY,
              w: offsetW * (logoABWidth - 20) / layouWidthOri,
              h: offsetH * (logoABHeight - 30) / layouHeightOri
            },
        },


        logoB: (this.previewLayout == 'submenu')
          ? {
            x: (offsetW * 366 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 43 / layouHeightOri + offsetY,
            w: offsetW * (logoABWidth - 160) / layouWidthOri,
            h: offsetH * (logoABHeight - 10) / layouHeightOri
          }
          : {
            x: (offsetW * 490 / layouWidthOri) + adjustMaxWidth,
            y: (this.hasLens() && !this.hasCoach())
              ? offsetH * 105 / layouHeightOri + offsetY
              : offsetH * 100 / layouHeightOri + offsetY,
            w: offsetW * (logoABWidth - 20) / layouWidthOri,
            h: offsetH * (logoABHeight + 40 ) / layouHeightOri
          },
        logoC: (this.previewLayout == 'submenu')
          ? {
            x: (offsetW * 580 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 150 / layouHeightOri + offsetY,
            w: offsetW * logoCDWidth / layouWidthOri,
            h: offsetH * logoCDHeight / layouHeightOri
          }
          : {
            x: (offsetW * 459 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 305 / layouHeightOri + offsetY,
            w: offsetW * logoCDWidth / layouWidthOri,
            h: offsetH * logoCDHeight / layouHeightOri
          },
        logoD: { x: (offsetW * 679 / layouWidthOri) + adjustMaxWidth, y: offsetH * 305 / layouHeightOri + offsetY, w: offsetW * logoCDWidth / layouWidthOri, h: offsetH * logoCDHeight / layouHeightOri },
        logoE: (this.previewLayout != 'submenu' && this.apps.includes(1) && this.apps.includes(3) && this.apps.includes(8))
          ? {
            x: (offsetW * 463 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 290 / layouHeightOri + offsetY,
            w: offsetW * logoEFWidth / layouWidthOri,
            h: offsetH * logoEFHeight / layouHeightOri
          }
          : (this.previewLayout == 'submenu' && ((this.apps.includes(1) && this.apps.includes(8) && !this.apps.includes(3)) || (this.apps.includes(1) && !this.apps.includes(8) && this.apps.includes(3))))
          ? {
            x: (offsetW * 463 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 288 / layouHeightOri + offsetY,
            w: offsetW * logoEFWidth / layouWidthOri,
            h: offsetH * logoEFHeight / layouHeightOri
          }
          : (this.previewLayout == 'submenu' && this.apps.includes(1) && this.apps.includes(8) && this.apps.includes(3))
          ? {
            x: (offsetW * 470 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 305 / layouHeightOri + offsetY,
            w: offsetW * logoEFWidth / layouWidthOri,
            h: offsetH * logoEFHeight / layouHeightOri
          }
          : {
            x: (offsetW * 463 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 313 / layouHeightOri + offsetY,
            w: offsetW * logoEFWidth / layouWidthOri,
            h: offsetH * logoEFHeight / layouHeightOri
          },
        logoF: (this.previewLayout != 'submenu' && this.apps.includes(1) && this.apps.includes(3) && this.apps.includes(8))
          ? {
            x: (offsetW * 675 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 290 / layouHeightOri + offsetY,
            w: offsetW * logoEFWidth / layouWidthOri,
            h: offsetH * logoEFHeight / layouHeightOri
          }
          : (this.previewLayout == 'submenu' && this.apps.includes(1) && this.apps.includes(8) && this.apps.includes(3))
          ? {
            x: (offsetW * 710 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 305 / layouHeightOri + offsetY,
            w: offsetW * logoEFWidth / layouWidthOri,
            h: offsetH * logoEFHeight / layouHeightOri
          }
          : (this.previewLayout == 'submenu')
          ? {
            x: (offsetW * 671 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 288 / layouHeightOri + offsetY,
            w: offsetW * logoEFWidth / layouWidthOri,
            h: offsetH * logoEFHeight / layouHeightOri
          }
          : {
            x: (offsetW * 671 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 313 / layouHeightOri + offsetY,
            w: offsetW * logoEFWidth / layouWidthOri,
            h: offsetH * logoEFHeight / layouHeightOri
          },
          logoG: (this.previewLayout != 'submenu' && this.apps.includes(1) && this.apps.includes(3) && this.apps.includes(8))
          ? {
            x: (offsetW * 570 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 360 / layouHeightOri + offsetY,
            w: offsetW * logoGFWidth / layouWidthOri,
            h: offsetH * logoGFHeight / layouHeightOri
          }
          : (this.previewLayout == 'submenu' && this.apps.includes(1) && this.apps.includes(8) && this.apps.includes(3))
          ? {
            x: (offsetW * 590 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 375 / layouHeightOri + offsetY,
            w: offsetW * logoGFWidth / layouWidthOri,
            h: offsetH * logoGFHeight / layouHeightOri
          }
          : (this.previewLayout == 'submenu' && this.apps.includes(1) && this.apps.includes(8) && !this.apps.includes(3))
          ? {
            x: (offsetW * 671 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 288 / layouHeightOri + offsetY,
            w: offsetW * logoGFWidth / layouWidthOri,
            h: offsetH * logoGFHeight / layouHeightOri
          }
          : (this.previewLayout == 'submenu')
          ? {
            x: (offsetW * 463 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 288 / layouHeightOri + offsetY,
            w: offsetW * logoGFWidth / layouWidthOri,
            h: offsetH * logoGFHeight / layouHeightOri
          }
          : {
            x: (offsetW * 671 / layouWidthOri) + adjustMaxWidth,
            y: offsetH * 313 / layouHeightOri + offsetY,
            w: offsetW * logoGFWidth / layouWidthOri,
            h: offsetH * logoGFHeight / layouHeightOri
          },
        logo1: {
          'opticalStore': { x: (offsetW * 400 / layouWidthOri) + adjustMaxWidth, y: offsetH * 130 / layouHeightOri + offsetY, w: offsetW * logo1Width / layouWidthOri, h: offsetH * logo1Height / layouHeightOri },
          'opticalStoreBeta': { x: (offsetW * 500 / layouWidthOri) + adjustMaxWidth , y: offsetH * 240 / layouHeightOri + (offsetY + 7), w: offsetW * (logo1Width - 175 ) / layouWidthOri, h: offsetH * (logo1Height - 89) / layouHeightOri },
          'opticalStoreStepper': { x: (offsetW * 500 / layouWidthOri) + adjustMaxWidth , y: offsetH * 175 / layouHeightOri + (offsetY + 7), w: offsetW * (logo1Width - 175 ) / layouWidthOri, h: offsetH * (logo1Height - 89) / layouHeightOri }
        },
        logo2: { x: offsetX + 20, y: offsetY + 10, w: offsetW * logoCDWidth / layouWidthOri, h: offsetH * logoCDHeight / layouHeightOri },
        logo3: { x: window.innerWidth - offsetW * logoCDWidth / layouWidthOri - 40 - this.previewLayoutObject.nativeElement.getBoundingClientRect().left, y: offsetY + 10, w: offsetW * logoCDWidth / layouWidthOri, h: offsetH * logoCDHeight / layouHeightOri },
        coverImage: { x: offsetX, y: offsetY, w: offsetW * imageCoverWidth / layouWidthOriPdfBi, h: offsetH * imageCoverHeight / layouHeightOriPdfBi },
        insidePageImage: { x: offsetX, y: offsetY + offsetH / 2, w: offsetW * insidePageImageWidth / layouWidthOriPdfBi, h: offsetH * insidePageImageHeight / layouHeightOriPdfBi },
      }
    }

  }

  checkFileExtension(_fileList: FileList, _name: string) {
    switch (_name) {
      case 'screenSaverVideo':
        if (this.extensionsVideo.includes(_fileList![0].name.substring(_fileList![0].name.lastIndexOf('.') + 1))) {
          this.fileExtError["videoFile"] = false;
        } else {
          this.fileExtError["videoFile"] = true;
        }
        break;
      default:
        if (this.extensions.includes(_fileList![0].name.substring(_fileList![0].name.lastIndexOf('.') + 1))) {
          this.fileExtError[_name] = false;
        } else {
          this.fileExtError[_name] = true;
        }
        break;
    }

  }

  getTouchedValues(form: any) {
    let touchedValues: { [key: string | number]: any } = {};

    Object.keys(form.controls)
      .forEach(key => {
        let currentControl = form.controls[key];

        if (currentControl.touched) {
          if (currentControl.controls)
            touchedValues[key] = this.getTouchedValues(currentControl);
          else
            touchedValues[key] = currentControl.value;
        }
      });

    return touchedValues;
  }

  checkAllFiles() {
    this.saveDisabled = false;
    Object.keys(this.fileExtError).map(key => this.fileExtError[key] ? this.saveDisabled = true : null);
    Object.keys(this.maxFileSizeExceed).map(key => this.maxFileSizeExceed[key] ? this.saveDisabled = true : null);
    const allowedAppsControl = this.settingsForm.get('allowedApps');
    if (this.entity.entityTypeId === 2) {
      if ((allowedAppsControl?.touched || this.allowedAppsInitialized) && allowedAppsControl?.invalid) {
        this.saveDisabled = true;
      }
    }
  }

  onAllowedAppsClose() {
    const allowedAppsControl = this.settingsForm.get('allowedApps');
    allowedAppsControl?.markAsTouched();
    this.checkAllFiles();
  }

  setSettingsObjectImage(_attr: string, _name: string, _image: string) {
    switch (_attr) {
      case 'logo1':
        !this.currentSettings!.appFrontendDesign.logo1 ? this.currentSettings!.appFrontendDesign.logo1 = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.logo1.logoImage = _image;
        this.currentSettings!.appFrontendDesign.logo1.logoName = _name;
        break;
      case 'logo2':
        !this.currentSettings!.appFrontendDesign.logo2 ? this.currentSettings!.appFrontendDesign.logo2 = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.logo2.logoImage = _image;
        this.currentSettings!.appFrontendDesign.logo2.logoName = _name;
        break;
      case 'logo3':
        !this.currentSettings!.appFrontendDesign.logo3 ? this.currentSettings!.appFrontendDesign.logo3 = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.logo3.logoImage = _image;
        this.currentSettings!.appFrontendDesign.logo3.logoName = _name;
        break;
      case 'distributorLogo':
        !this.currentSettings!.appFrontendDesign.distributorLogo ? this.currentSettings!.appFrontendDesign.distributorLogo = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.distributorLogo.logoImage = _image;
        this.currentSettings!.appFrontendDesign.distributorLogo.logoName = _name;
        break;
      case 'mimesysProductLogo':
        !this.currentSettings!.appFrontendDesign.mimesysProductLogo ? this.currentSettings!.appFrontendDesign.mimesysProductLogo = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.mimesysProductLogo.logoImage = _image;
        this.currentSettings!.appFrontendDesign.mimesysProductLogo.logoName = _name;
        break;
      case 'lensLogo':
        !this.currentSettings!.appFrontendDesign.lensLogo ? this.currentSettings!.appFrontendDesign.lensLogo = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.lensLogo.logoImage = _image;
        this.currentSettings!.appFrontendDesign.lensLogo.logoName = _name;
        break;
      case 'coachLogo':
        !this.currentSettings!.appFrontendDesign.coachLogo ? this.currentSettings!.appFrontendDesign.coachLogo = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.coachLogo.logoImage = _image;
        this.currentSettings!.appFrontendDesign.coachLogo.logoName = _name;
        break;
      case 'progressiveLogo':
        !this.currentSettings!.appFrontendDesign.progressiveLogo ? this.currentSettings!.appFrontendDesign.progressiveLogo = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.progressiveLogo.logoImage = _image;
        this.currentSettings!.appFrontendDesign.progressiveLogo.logoName = _name;
        break;
      case 'officeLogo':
        !this.currentSettings!.appFrontendDesign.officeLogo ? this.currentSettings!.appFrontendDesign.officeLogo = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.officeLogo.logoImage = _image;
        this.currentSettings!.appFrontendDesign.officeLogo.logoName = _name;
        break;
      case 'svisionLogo':
        !this.currentSettings!.appFrontendDesign.svisionLogo ? this.currentSettings!.appFrontendDesign.svisionLogo = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.svisionLogo.logoImage = _image;
        this.currentSettings!.appFrontendDesign.svisionLogo.logoName = _name;
        break;
      case 'progressiveLogoSubmenu':
        !this.currentSettings!.appFrontendDesign.progressiveLogoSubmenu ? this.currentSettings!.appFrontendDesign.progressiveLogoSubmenu = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.progressiveLogoSubmenu.logoImage = _image;
        this.currentSettings!.appFrontendDesign.progressiveLogoSubmenu.logoName = _name;
        break;
      case 'officeLogoSubmenu':
        !this.currentSettings!.appFrontendDesign.officeLogoSubmenu ? this.currentSettings!.appFrontendDesign.officeLogoSubmenu = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.officeLogoSubmenu.logoImage = _image;
        this.currentSettings!.appFrontendDesign.officeLogoSubmenu.logoName = _name;
        break;
      case 'svisionLogoSubmenu':
        !this.currentSettings!.appFrontendDesign.svisionLogoSubmenu ? this.currentSettings!.appFrontendDesign.svisionLogoSubmenu = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.svisionLogoSubmenu.logoImage = _image;
        this.currentSettings!.appFrontendDesign.svisionLogoSubmenu.logoName = _name;
        break;
      case 'ergoCorridorLogo':
        !this.currentSettings!.appFrontendDesign.ergoCorridorLogo ? this.currentSettings!.appFrontendDesign.ergoCorridorLogo = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.ergoCorridorLogo.logoImage = _image;
        this.currentSettings!.appFrontendDesign.ergoCorridorLogo.logoName = _name;
        break;
      case 'coverImage':
        !this.currentSettings!.appFrontendDesign.coverImage ? this.currentSettings!.appFrontendDesign.coverImage = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.coverImage.logoImage = _image;
        this.currentSettings!.appFrontendDesign.coverImage.logoName = _name;
        break;
      case 'insidePageImage':
        !this.currentSettings!.appFrontendDesign.insidePageImage ? this.currentSettings!.appFrontendDesign.insidePageImage = { logoName: _name } : null;
        this.currentSettings!.appFrontendDesign.insidePageImage.logoImage = _image;
        this.currentSettings!.appFrontendDesign.insidePageImage.logoName = _name;
        break;
    }
  }

  getFileNameFromPath(_path: String, _file?: string) {
    this.actualFilenames[_file!] = _path.replace(/^.*[\\/]/, '');
  }

  async uploadFile(event: Event, _name: string) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    
    if (!fileList || fileList.length === 0) return;
    
    const file = fileList[0];
    const control = this.settingsForm.get(_name);
    
    if (!control) return;
    
    // Validar con el servicio centralizado
    if (!this.fileSpecsService.validateAndSetFormControl(_name, file, control, element)) {
      return;
    }

    this.getFileNameFromPath(fileList[0].name, _name);

    let idObject: string | number = ''
    idObject = _name;

    if (idObject == 'screenSaverVideo') {
      !this.currentSettings!.screenSaver ? this.currentSettings!.screenSaver = { enabled: false } : null;
      this.currentSettings!.screenSaverVideo = fileList[0];
      this.currentSettings!.screenSaverVideoData = await utils.toBase64(_name, this.entity.id);
      this.currentSettings!.screenSaver.fileName = fileList[0].name;
      this.currentSettings!.screenSaver.size = fileList[0].size
      this.currentSettings!.screenSaver.mimeType = fileList[0].type
      this.settingsForm.controls.screenSaverEnabled.enable()
    } else {
      this.setSettingsObjectImage(idObject, this.actualFilenames[_name], await utils.toBase64(_name, this.entity.id))
    }
  }

  async submit() {
    this.settingsForm.controls.requestToken.enable();
    const update: SettingsMimesys = {
      entityId: this.settingsForm.value.entityId,
      parentEntityId: this.settingsForm.value.parentEntityId!,
      language: this.settingsForm.value.language!,
      template: this.settingsForm.value.template!,
      color: this.settingsForm.value.color!,
      onlyVisibleBy: this.settingsForm.value.onlyVisibleBy!,
      // progresiveTopName: this.settingsForm.value.progresiveTopName,
      // progresiveMidName: this.settingsForm.value.progresiveMidName,
      // progresiveBasicName: this.settingsForm.value.progresiveBasicName,
      environments_3d: {
        lp_environment_id: this.enviromentLensPro.find(
          el => el.value == this.settingsForm.value.enviromentLensPro
        )?.id,
        lo_environment_id: this.enviromentLensOffice.find(
          el => el.value == this.settingsForm.value.enviromentLensOffice
        )?.id,
        cp_environment_id: this.enviromentCoachProgre.find(
          el => el.value == this.settingsForm.value.enviromentCoachProgre
        )?.id,
        co_environment_id: this.enviromentCoachOffice.find(
          el => el.value == this.settingsForm.value.enviromentCoachOffice
        )?.id,
        launcher_environment_id: this.enviromentLauncher.find(
          el => el.value == this.settingsForm.value.enviromentLauncher
        )?.id,
        comparison_environment_id: this.enviromentComparison.find(
          el => el.value == this.settingsForm.value.enviromentComparison
        )?.id,
        ls_environment_id: this.enviromentLensSvision.find(
          el => el.value == this.settingsForm.value.enviromentLensSvision
        )?.id,
      },
      externalReporting: {
        service: this.settingsForm.value.service!,
        enabled: this.settingsForm.value.externalReportingEnabled,
      },
      main: this.settingsForm.value.main!,
      appUser: this.settingsForm.value.appUser,
      appPwd: this.settingsForm.value.appPwd,
      externalRequest: {
        requestToken: this.settingsForm.value.requestToken,
        enabled: this.settingsForm.value.enabled
      },
      shortTestID: this.settingsForm.value.shortTestID,
      ergoCorridorEnable: this.settingsForm.value.ergoCorridorEnable!,
      ergoCorridorName: this.settingsForm.value.ergoCorridorName!,
      mapsDisplay: this.settingsForm.value.mapsDisplay!,
      gazeType: this.settingsForm.value.gazeType!,
      amplitudeRatio: this.settingsForm.value.amplitudeRatio!,
      maxFrequencyVector: this.settingsForm.value.maxFrequencyVector!,
      diagnostic: this.settingsForm.value.diagnostic!,
      additionalMapsDisplay: this.settingsForm.value.additionalMapsDisplay!,
      timezone: this.entity.timezone,
      appFrontendDesign: {
        logo1: {
          logoImage: this.settingsForm.get('logo1')?.value && this.currentSettings?.appFrontendDesign?.logo1?.logoImage
            ? (await utils.toBase64('logo1', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.logo1?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.logo1?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('logo1')?.value && this.currentSettings?.appFrontendDesign?.logo1?.logoName
            ? (this.settingsForm.get('logo1')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.logo1?.logoName ?? '',
          allowConfiguration: this.settingsForm.value.logo1Allow!,
        },
        logo2: {
          logoImage: this.settingsForm.get('logo2')?.value && this.currentSettings?.appFrontendDesign?.logo2?.logoImage
            ? (await utils.toBase64('logo2', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.logo2?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.logo2?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('logo2')?.value && this.currentSettings?.appFrontendDesign?.logo2?.logoName
            ? (this.settingsForm.get('logo2')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.logo2?.logoName ?? '',
        },
        logo3: {
          logoImage: this.settingsForm.get('logo3')?.value && this.currentSettings?.appFrontendDesign?.logo3?.logoImage
            ? (await utils.toBase64('logo3', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.logo3?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.logo3?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('logo3')?.value && this.currentSettings?.appFrontendDesign?.logo3?.logoName
            ? (this.settingsForm.get('logo3')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.logo3?.logoName ?? '',
          allowConfiguration: this.settingsForm.value.logo3Allow!
        },
        distributorLogo: {
          logoImage: this.settingsForm.get('distributorLogo')?.value && this.currentSettings?.appFrontendDesign?.distributorLogo?.logoImage
            ? (await utils.toBase64('distributorLogo', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.distributorLogo?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.distributorLogo?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('distributorLogo')?.value && this.currentSettings?.appFrontendDesign?.distributorLogo?.logoName
            ? (this.settingsForm.get('distributorLogo')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.distributorLogo?.logoName ?? '',
          allowConfiguration: this.settingsForm.value.distributorLogoAllow!,
        },
        mimesysProductLogo: {
          logoImage: this.settingsForm.get('mimesysProductLogo')?.value && this.currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage
            ? (await utils.toBase64('mimesysProductLogo', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('mimesysProductLogo')?.value && this.currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoName
            ? (this.settingsForm.get('mimesysProductLogo')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.mimesysProductLogo?.logoName ?? '',
        },
        lensLogo: {
          logoImage: this.settingsForm.get('lensLogo')?.value && this.currentSettings?.appFrontendDesign?.lensLogo?.logoImage
            ? (await utils.toBase64('lensLogo', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.lensLogo?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.lensLogo?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('lensLogo')?.value && this.currentSettings?.appFrontendDesign?.lensLogo?.logoName
            ? (this.settingsForm.get('lensLogo')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.lensLogo?.logoName ?? '',
        },
        coachLogo: {
          logoImage: this.settingsForm.get('coachLogo')?.value && this.currentSettings?.appFrontendDesign?.coachLogo?.logoImage
            ? (await utils.toBase64('coachLogo', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.coachLogo?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.coachLogo?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('coachLogo')?.value && this.currentSettings?.appFrontendDesign?.coachLogo?.logoName
            ? (this.settingsForm.get('coachLogo')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.coachLogo?.logoName ?? '',
        },
        progressiveLogo: {
          logoImage: this.settingsForm.get('progressiveLogo')?.value && this.currentSettings?.appFrontendDesign?.progressiveLogo?.logoImage
            ? (await utils.toBase64('progressiveLogo', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.progressiveLogo?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.progressiveLogo?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('progressiveLogo')?.value && this.currentSettings?.appFrontendDesign?.progressiveLogo?.logoName
            ? (this.settingsForm.get('progressiveLogo')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.progressiveLogo?.logoName ?? '',
        },
        officeLogo: {
          logoImage: this.settingsForm.get('officeLogo')?.value && this.currentSettings?.appFrontendDesign?.officeLogo?.logoImage
            ? (await utils.toBase64('officeLogo', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.officeLogo?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.officeLogo?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('officeLogo')?.value && this.currentSettings?.appFrontendDesign?.officeLogo?.logoName
            ? (this.settingsForm.get('officeLogo')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.officeLogo?.logoName ?? '',
        },
        svisionLogo: {
          logoImage: this.settingsForm.get('svisionLogo')?.value && this.currentSettings?.appFrontendDesign?.svisionLogo?.logoImage
            ? (await utils.toBase64('svisionLogo', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.svisionLogo?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.svisionLogo?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('svisionLogo')?.value && this.currentSettings?.appFrontendDesign?.svisionLogo?.logoName
            ? (this.settingsForm.get('svisionLogo')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.svisionLogo?.logoName ?? '',
        },
        progressiveLogoSubmenu: {
          logoImage: this.settingsForm.get('progressiveLogoSubmenu')?.value && this.currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage
            ? (await utils.toBase64('progressiveLogoSubmenu', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('progressiveLogoSubmenu')?.value && this.currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoName
            ? (this.settingsForm.get('progressiveLogoSubmenu')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.progressiveLogoSubmenu?.logoName ?? '',
        },
        officeLogoSubmenu: {
          logoImage: this.settingsForm.get('officeLogoSubmenu')?.value && this.currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage
            ? (await utils.toBase64('officeLogoSubmenu', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('officeLogoSubmenu')?.value && this.currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoName
            ? (this.settingsForm.get('officeLogoSubmenu')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.officeLogoSubmenu?.logoName ?? '',
        },
        svisionLogoSubmenu: {
          logoImage: this.settingsForm.get('svisionLogoSubmenu')?.value && this.currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage
            ? (await utils.toBase64('svisionLogoSubmenu', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('svisionLogoSubmenu')?.value && this.currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoName
            ? (this.settingsForm.get('svisionLogoSubmenu')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.svisionLogoSubmenu?.logoName ?? '',
        },
        ergoCorridorLogo: {
          logoImage: this.settingsForm.get('ergoCorridorLogo')?.value && this.currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoImage
            ? (await utils.toBase64('ergoCorridorLogo', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('ergoCorridorLogo')?.value && this.currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoName
            ? (this.settingsForm.get('ergoCorridorLogo')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.ergoCorridorLogo?.logoName ?? '',
        },
        coverImage: {
          logoImage: this.settingsForm.get('coverImage')?.value && this.currentSettings?.appFrontendDesign?.coverImage?.logoImage
            ? (await utils.toBase64('coverImage', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.coverImage?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.coverImage?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('coverImage')?.value && this.currentSettings?.appFrontendDesign?.coverImage?.logoName
            ? (this.settingsForm.get('coverImage')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.coverImage?.logoName ?? '',
        },
        insidePageImage: {
          logoImage: this.settingsForm.get('insidePageImage')?.value && this.currentSettings?.appFrontendDesign?.insidePageImage?.logoImage
            ? (await utils.toBase64('insidePageImage', this.entity.id)).replace(',', ", ")
            : (this.currentSettings?.appFrontendDesign?.insidePageImage?.logoImage?.replace(',', ", ")
              ? this.currentSettings?.appFrontendDesign?.insidePageImage?.logoImage?.replace(',', ", ")
              : ''),
          logoName: this.settingsForm.get('insidePageImage')?.value && this.currentSettings?.appFrontendDesign?.insidePageImage?.logoName
            ? (this.settingsForm.get('insidePageImage')?.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.insidePageImage?.logoName ?? '',
        }
      },
      screenSaver: {
        enabled: this.settingsForm.controls.screenSaverEnabled.value,
        fileName: this.currentSettings?.screenSaver?.fileName ? this.currentSettings?.screenSaver?.fileName : '',
        mimeType: this.currentSettings!.screenSaver?.mimeType,
      }
    }
    
    // Only add allowedApps if it has at least one item (backend requires minItems: 1)
    const allowedAppsValue = this.settingsForm.value.allowedApps ?? [];
    if (Array.isArray(allowedAppsValue) && allowedAppsValue.length > 0) {
      update['allowedApps'] = allowedAppsValue;
    }
    // if (this.entity.entityTypeId === 2 || this.entity.entityTypeId === 3) {
    //   update['childs'] = this.user.childEntities!.filter(
    //     (entity: Entity) => entity.parentEntityId === this.entity.id && entity.entityTypeId === 4
    //   );
    // } else {
    //   update['childs'] = null;
    // }

    //do not send image once it has been eliminated and the control form has not been touched
    let touchedControls = this.getTouchedValues(this.settingsForm);
    let imagesTouched: string[] = ['logo1', 'logo2', 'logo3', 'distributorLogo', 'mimesysProductLogo', 'lensLogo',
      'coachLogo', 'progressiveLogo', 'officeLogo', 'svisionLogo', 'progressiveLogoSubmenu', 'officeLogoSubmenu', 'svisionLogoSubmenu', 'ergoCorridorLogo', 'coverImage', 'insidePageImage'];
    imagesTouched.map(image => {
      switch (image) {
        case 'logo1':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.logo1?.logoImage && delete update.appFrontendDesign.logo1?.logoName
          break;
        case 'logo2':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.logo2?.logoImage && delete update.appFrontendDesign.logo2?.logoName
          break;
        case 'logo3':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.logo3?.logoImage && delete update.appFrontendDesign.logo3?.logoName
          break;
        case 'distributorLogo':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.distributorLogo?.logoImage && delete update.appFrontendDesign.distributorLogo?.logoName
          break;
        case 'mimesysProductLogo':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.mimesysProductLogo?.logoImage && delete update.appFrontendDesign.mimesysProductLogo?.logoName
          break;
        case 'lensLogo':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.lensLogo?.logoImage && delete update.appFrontendDesign.lensLogo?.logoName
          break;
        case 'coachLogo':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.coachLogo?.logoImage && delete update.appFrontendDesign.coachLogo?.logoName
          break;
        case 'progressiveLogo':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.progressiveLogo?.logoImage && delete update.appFrontendDesign.progressiveLogo?.logoName
          break;
        case 'officeLogo':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.officeLogo?.logoImage && delete update.appFrontendDesign.officeLogo?.logoName
          break;
        case 'svisionLogo':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.svisionLogo?.logoImage && delete update.appFrontendDesign.svisionLogo?.logoName
          break;
        case 'progressiveLogoSubmenu':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.progressiveLogoSubmenu?.logoImage && delete update.appFrontendDesign.progressiveLogoSubmenu?.logoName
          break;
        case 'officeLogoSubmenu':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.officeLogoSubmenu?.logoImage && delete update.appFrontendDesign.officeLogoSubmenu?.logoName
          break;
        case 'svisionLogoSubmenu':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.svisionLogoSubmenu?.logoImage && delete update.appFrontendDesign.svisionLogoSubmenu?.logoName
          break;
        case 'ergoCorridorLogo':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.ergoCorridorLogo?.logoImage && delete update.appFrontendDesign.ergoCorridorLogo?.logoName
          break;
        case 'coverImage':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.coverImage?.logoImage && delete update.appFrontendDesign.coverImage?.logoName
          break;
        case 'insidePageImage':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign.insidePageImage?.logoImage && delete update.appFrontendDesign.insidePageImage?.logoName
          break;
        case 'screenSaverVideo':
          if (touchedControls[image] === undefined) delete update.screenSaverVideo && delete update.screenSaverVideoData;
          break;
        default:
          break;
      }
    })

    const data_to_update = { "settings": this.cleanParams(update) }
    this.settingsForm.controls.requestToken.disable();
    const video_data = { "size": this.currentSettings?.screenSaver?.size, "mimeType": this.currentSettings?.screenSaver?.mimeType }
    this.settingsService.updateMimesys(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId, data_to_update).subscribe(async res => {
      this.configSvc.setConfigSettingsValue('settings', this.entity.id, 'mimesys', res);
      if (touchedControls["screenSaverVideo"] !== undefined && this.currentSettings?.screenSaverVideo) {
        this.settingsService.uploadVideoMimesys(this.entity.internalCode, video_data).subscribe(res => {
          this.settingsService.putScreenSaver(res["url"], this.currentSettings?.screenSaverVideo).subscribe(res => { console.log(res) })
        });
      }
    })
  }

  onChange(id: string, _type?: string) {
    switch (_type) {
      case 'enviromentLauncher':
        this.staticImagesLauncher(id);
        break
      default:
        break;
    }
  }

  showImage(e: Event, _image?: string) {
    e.preventDefault();
    var image = new Image();
    image.src = _image!;
    var w = window.open("", "_blank");
    w!.document.write(image.outerHTML);
  }
  showVideo(e: Event, _image?: string) {
    e.preventDefault();
    var image = new Image();
    image.src = _image!;
    var w = window.open("", "_blank");
    w!.document.write(      "<html style='margin: 0; padding: 0; overflow: hidden;'>" +
      "<body style='margin: 0; padding: 0; background-color: #212121; width: 100vw; height: 100vh; display: flex; justify-content: center; align-items: center; overflow: hidden;'>" +
      "<video style='width: 100%; height: 100%; object-fit: contain;' controls>" +
      "<source src='" + _image + "' type='video/mp4'>" +
      "<source src='" + _image + "' type='video/ogg'>" +
      "Your browser does not support the video tag." +
      "</video>" +
      "</body></html>"
    );
  }
  getImage(_image?: string) {
    return _image
  }

  clearImage(e: Event, image?: string) {
    e.preventDefault();

    this.settingsForm.get(image?.split('-')[0] as any)?.patchValue('');
    this.settingsForm.get(image?.split('-')[0] as any)?.markAsTouched({ onlySelf: true });

    this.deleteSettingsObjectImage(image!);
  }

  deleteSettingsObjectImage(_attr: number | string) {
    switch (_attr) {
      case 'logo1':
        Object.keys(this.currentSettings!.appFrontendDesign.logo1!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.logo1 = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.logo1!)
          }
          return result;
        }, {})
        break;
      case 'logo2':
        Object.keys(this.currentSettings!.appFrontendDesign.logo2!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.logo2 = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.logo2!)
          }
          return result;
        }, {})
        break;
      case 'logo3':
        Object.keys(this.currentSettings!.appFrontendDesign.logo3!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.logo3 = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.logo3!)
          }
          return result;
        }, {})
        break;
      case 'distributorLogo':
        Object.keys(this.currentSettings!.appFrontendDesign.distributorLogo!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.distributorLogo = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.distributorLogo!)
          }
          return result;
        }, {})
        break;
      case 'mimesysProductLogo':
        Object.keys(this.currentSettings!.appFrontendDesign.mimesysProductLogo!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.mimesysProductLogo = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.mimesysProductLogo!)
          }
          return result;
        }, {})
        break;
      case 'lensLogo':
        Object.keys(this.currentSettings!.appFrontendDesign.lensLogo!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.lensLogo = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.lensLogo!)
          }
          return result;
        }, {})
        break;
      case 'coachLogo':
        Object.keys(this.currentSettings!.appFrontendDesign.coachLogo!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.coachLogo = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.coachLogo!)
          }
          return result;
        }, {})
        break;
      case 'progressiveLogo':
        Object.keys(this.currentSettings!.appFrontendDesign.progressiveLogo!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.progressiveLogo = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.progressiveLogo!)
          }
          return result;
        }, {})
        break;
      case 'officeLogo':
        Object.keys(this.currentSettings!.appFrontendDesign.officeLogo!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.officeLogo = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.officeLogo!)
          }
          return result;
        }, {})
        break;
      case 'svisionLogo':
        Object.keys(this.currentSettings!.appFrontendDesign.svisionLogo!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.svisionLogo = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.svisionLogo!)
          }
          return result;
        }, {})
        break;
      case 'progressiveLogoSubmenu':
        Object.keys(this.currentSettings!.appFrontendDesign.progressiveLogoSubmenu!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.progressiveLogoSubmenu = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.progressiveLogoSubmenu!)
          }
          return result;
        }, {})
        break;
      case 'officeLogoSubmenu':
        Object.keys(this.currentSettings!.appFrontendDesign.officeLogoSubmenu!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.officeLogoSubmenu = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.officeLogoSubmenu!)
          }
          return result;
        }, {})
        break;
      case 'svisionLogoSubmenu':
        Object.keys(this.currentSettings!.appFrontendDesign.svisionLogoSubmenu!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.svisionLogoSubmenu = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.svisionLogoSubmenu!)
          }
          return result;
        }, {})
        break;
      case 'ergoCorridorLogo':
        Object.keys(this.currentSettings!.appFrontendDesign.ergoCorridorLogo!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.ergoCorridorLogo = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.ergoCorridorLogo!)
          }
          return result;
        }, {})
        break;
      case 'coverImage':
        Object.keys(this.currentSettings!.appFrontendDesign.coverImage!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.coverImage = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.coverImage!)
          }
          return result;
        }, {})
        break;
      case 'insidePageImage':
        Object.keys(this.currentSettings!.appFrontendDesign.insidePageImage!).reduce((result: { [key: string | number]: any }, key: number | string) => {
          if (key !== _attr) {
            this.currentSettings!.appFrontendDesign.insidePageImage = (({ logoImage, logoName, ...o }) => o)(this.currentSettings!.appFrontendDesign.insidePageImage!)
          }
          return result;
        }, {})
        break;
      case 'screenSaverVideo':
        this.currentSettings!.screenSaver = {
          enabled: this.currentSettings!.screenSaver?.enabled!,
          fileName: "",
          mimeType: ""
        };
        this.currentSettings!.screenSaverVideo = '';
        this.currentSettings!.screenSaverVideoData = '';
        this.maxFileSizeExceed["videoFile"] = false;
        this.fileExtError["videoFile"] = false;
        this.settingsForm.controls.screenSaverEnabled.patchValue(false)
        this.settingsForm.controls.screenSaverEnabled.disable()
        break;
    }
  }

  joker(_value: string) {
    console.log(_value)
  }

  mapCurrentSettings() {
    this.currentSettings!.language = this.settingsForm.controls.language.value!;
    this.currentSettings!.entityId = this.settingsForm.controls.entityId.value!;
    this.currentSettings!.parentEntityId = this.settingsForm.controls.parentEntityId.value!;
    this.currentSettings!.template = this.settingsForm.controls.template.value!;
    this.currentSettings!.color = this.settingsForm.controls.color.value!;
    this.currentSettings!.appFrontendDesign!.logo1!.allowConfiguration = this.settingsForm.controls.logo1Allow.value!;
    this.currentSettings!.appFrontendDesign!.logo3!.allowConfiguration = this.settingsForm.controls.logo3Allow.value!;
    this.currentSettings!.onlyVisibleBy = this.settingsForm.controls.onlyVisibleBy.value!;
    // this.currentSettings!.progresiveTopName = this.settingsForm.controls.progresiveTopName.value!;
    // this.currentSettings!.progresiveMidName = this.settingsForm.controls.progresiveMidName.value!;
    // this.currentSettings!.progresiveBasicName = this.settingsForm.controls.progresiveBasicName.value!;
    this.currentSettings!.environments_3d!.lp_environment_id = this.settingsForm.controls.enviromentLensPro.value!;
    this.currentSettings!.environments_3d!.lo_environment_id = this.settingsForm.controls.enviromentLensOffice.value!;
    this.currentSettings!.environments_3d!.cp_environment_id = this.settingsForm.controls.enviromentCoachProgre.value!;
    this.currentSettings!.environments_3d!.ls_environment_id = this.settingsForm.controls.enviromentLensSvision.value!;
    this.currentSettings!.environments_3d!.co_environment_id = this.settingsForm.controls.enviromentCoachOffice.value!;
    this.currentSettings!.environments_3d!.launcher_environment_id = this.settingsForm.controls.enviromentLauncher.value!;
    this.currentSettings!.environments_3d!.comparison_environment_id = this.settingsForm.controls.enviromentComparison.value!;
    this.currentSettings!.externalReporting!.service = this.settingsForm.controls.service.value!;
    this.currentSettings!['main'] = this.settingsForm.controls.main.value!;
    this.currentSettings!.appUser = this.settingsForm.controls.appUser.value!;
    this.currentSettings!.appPwd = this.settingsForm.controls.appPwd.value!;
    this.currentSettings!.externalRequest!.requestToken = this.settingsForm.controls.requestToken.value!;
    this.currentSettings!.externalRequest!.enabled = this.settingsForm.controls.enabled.value!;
    this.currentSettings!.shortTestID = this.settingsForm.controls.shortTestID.value!;
    this.currentSettings!.ergoCorridorEnable = this.settingsForm.controls.ergoCorridorEnable.value!;
    this.currentSettings!.ergoCorridorName = this.settingsForm.controls.ergoCorridorName.value!;
    this.currentSettings!.screenSaverEnabled = this.settingsForm.controls.screenSaverEnabled.value!;
    this.currentSettings!.screenSaver.enabled = this.settingsForm.controls.screenSaverEnabled.value!;
    this.currentSettings!.screenSaver.fileName = this.settingsForm.controls.screenSaverFileName.value!;
    this.currentSettings!.screenSaver.mimeType = this.settingsForm.controls.screenSaverMimeType.value!;
    this.currentSettings!.mapsDisplay = this.settingsForm.controls.mapsDisplay.value!;
    this.currentSettings!.gazeType = this.settingsForm.controls.gazeType.value!;
    this.currentSettings!.amplitudeRatio = this.settingsForm.controls.amplitudeRatio.value!;
    this.currentSettings!.maxFrequencyVector = this.settingsForm.controls.maxFrequencyVector.value!;
    this.currentSettings!.diagnostic = this.settingsForm.controls.diagnostic.value!;
    this.currentSettings!.additionalMapsDisplay = this.settingsForm.controls.additionalMapsDisplay.value!;
    this.currentSettings!['allowedApps'] = this.settingsForm.controls.allowedApps.value?? [];
  }
}
